<script>
  export let src;
  export let diameter;
  export let alt;
</script>

<img src='{src}' style="width: {diameter}; height: {diameter};" alt={alt}>

<style>
  img {
    border-radius: 50%;
    object-fit: cover;
  }
</style>